import { useEffect, useState } from 'react';

// This hook checks to make sure if there is sufficient vertical space beneath the button to toggle full view of data sources
// If there is not enough space beneath, then render above.
export const usePanelPosition = (
  isExpanded: boolean,
  configMode: string | null,
  buttonRef: React.RefObject<HTMLButtonElement>
) => {
  const [panelPosition, setPanelPosition] = useState('down');

  useEffect(() => {
    // Only calculate position when panel first expands, not when configMode changes
    if (isExpanded && buttonRef.current && configMode === null) {
      const buttonRect = buttonRef.current.getBoundingClientRect();
      const spaceAbove = buttonRect.top;
      const spaceBelow = window.innerHeight - buttonRect.bottom;

      // Use the larger panel height for initial calculation to ensure enough space
      // This prevents the panel from needing to reposition when entering config mode
      const panelHeight = 500;

      // Add buffer space for smooth positioning and dropdown menus
      const buffer = 50;
      const requiredSpaceBelow = panelHeight + buffer;
      const requiredSpaceAbove = panelHeight + buffer;

      // Prefer showing panel below, but if not enough space below and enough above, show above
      if (spaceBelow < requiredSpaceBelow && spaceAbove >= requiredSpaceAbove) {
        setPanelPosition('up');
      } else {
        setPanelPosition('down');
      }
    }
  }, [isExpanded, configMode, buttonRef]);

  return panelPosition;
};
